import { Component } from "@angular/core";
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-cookies-modal",
  templateUrl: "./cookies-modal.component.html",
  styleUrls: ["./cookies-modal.component.scss"],
  imports: [MatDialogActions, MatDialogContent, TranslatePipe],
})
export class CookiesModalComponent {
  constructor(public dialogRef: MatDialogRef<CookiesModalComponent>) {}
}
